import { createContext, useContext } from 'react'
import PropTypes from 'prop-types'
import { useProvideAuth } from '../../auth/hooks/useProvideAuth'
import { getSessionAccessToken } from '../../auth/utils'

export const authContext = createContext()

const AuthProvider = ({ children }) => {
  const { isAuthenticated, handleLogout } = useProvideAuth()

  return (
    !!getSessionAccessToken() && (
      <authContext.Provider value={{ isAuthenticated, handleLogout }}>{children}</authContext.Provider>
    )
  )
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export const useAuth = () => useContext(authContext)

export default AuthProvider
